module.exports = "div.form-group input[type=checkbox] {\r\n  margin-top: 11px;\r\n}\r\n"